/* Progressive enhancement: native Shopify forms and links remain usable without JS. */
(() => {
  'use strict';
  const body = document.body;
  const drawer = document.getElementById('CartDrawer');
  let drawerTrigger = null;
  let cartOperation = false;
  let addOperation = false;
  const supportsDrawer = drawer && typeof drawer.showModal === 'function';
  document.querySelectorAll('select[data-default]').forEach(select => {
    if ([...select.options].some(option => option.value === select.dataset.default)) select.value = select.dataset.default;
  });
  const route = (name, fallback) => body.dataset[name] || fallback;
  const jsonEndpoint = (url) => `${url.replace(/\/$/, '')}.js`;
  const errorMessage = (error) => typeof error?.description === 'string' ? error.description : typeof error?.message === 'string' ? error.message : 'Something went wrong. Please try again or use the bag page.';
  const el = (name, className, text) => {
    const node = document.createElement(name);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const safeUrl = (value, fallback) => {
    try {
      const url = new URL(value, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : fallback;
    } catch { return fallback; }
  };
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100); }
    catch { return `${(cents / 100).toFixed(2)} ${currency || ''}`.trim(); }
  };
  async function requestJSON(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); }
    catch { throw new Error('The store could not complete this request. Please try again.'); }
    if (!response.ok) throw new Error(errorMessage(data));
    return data;
  }
  function message(text, isError = false) {
    if (!drawer) return;
    const node = drawer.querySelector('[data-drawer-message]');
    node.textContent = text;
    node.classList.toggle('error', isError);
  }
  function paintCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = node.closest('.drawer-heading') ? `(${cart.item_count})` : String(cart.item_count);
    });
    const currency = cart.currency || 'USD';
    const items = drawer.querySelector('[data-drawer-items]');
    items.replaceChildren();
    if (!cart.items.length) {
      items.append(el('p', 'section-space-top', 'Your bag is empty. Find a little clarity, one page at a time.'));
    }
    for (const item of cart.items) {
      const row = el('article', 'drawer-item');
      if (item.image) {
        const image = el('img', 'drawer-item-image');
        image.src = safeUrl(item.image, '');
        image.alt = item.product_title || item.title;
        image.width = 75; image.height = 110; image.loading = 'lazy';
        row.append(image);
      }
      const content = el('div');
      const title = el('h3');
      const link = el('a', '', item.product_title || item.title);
      link.href = safeUrl(item.url, route('cartUrl', '/cart'));
      title.append(link); content.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') content.append(el('p', 'small', item.variant_title));
      content.append(el('p', '', `Quantity: ${item.quantity}`));
      content.append(el('p', '', money(item.final_line_price, currency)));
      const remove = el('button', 'drawer-remove', 'Remove');
      remove.type = 'button'; remove.dataset.removeLine = item.key;
      remove.setAttribute('aria-label', `Remove ${item.product_title || item.title}`);
      content.append(remove); row.append(content); items.append(row);
    }
    drawer.querySelector('[data-drawer-total]').textContent = money(cart.total_price, currency);
    drawer.querySelector('button[name="checkout"]').disabled = cart.items.length === 0;
  }
  function showDrawer(trigger) {
    if (!supportsDrawer) return;
    if (!drawer.open) {
      drawerTrigger = trigger || document.activeElement;
      drawer.showModal();
      drawer.querySelector('[data-close-cart]').focus();
    }
  }
  function closeDrawer() { if (drawer?.open) drawer.close(); }
  drawer?.addEventListener('close', () => {
    if (drawerTrigger instanceof HTMLElement && drawerTrigger.isConnected) drawerTrigger.focus();
  });
  drawer?.addEventListener('click', event => {
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
    }
  });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-open-cart]');
    if (trigger && supportsDrawer && body.dataset.cartMode === 'drawer' && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); showDrawer(trigger); message('Loading your bag…');
      if (cartOperation || addOperation) return;
      cartOperation = true;
      try { paintCart(await requestJSON(jsonEndpoint(route('cartUrl', '/cart')))); message(''); }
      catch (error) { message(error.message, true); }
      finally { cartOperation = false; }
    }
    if (event.target.closest('[data-close-cart]')) closeDrawer();
    const remove = event.target.closest('[data-remove-line]');
    if (remove && !cartOperation && !addOperation) {
      cartOperation = true; remove.disabled = true; message('Updating your bag…');
      try {
        const updated = await requestJSON(jsonEndpoint(route('cartChangeUrl', '/cart/change')), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.removeLine, quantity: 0 }) });
        paintCart(updated); message('Item removed.'); drawer.querySelector('[data-close-cart]').focus();
      } catch (error) { message(error.message, true); remove.disabled = false; }
      finally { cartOperation = false; }
    }
    if (event.target.closest('.mobile-menu nav a')) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
    const copy = event.target.closest('[data-copy-code]');
    if (copy) {
      const feedback = document.querySelector('[data-copy-message]');
      try { await navigator.clipboard.writeText(copy.dataset.code); feedback.textContent = 'Code copied.'; }
      catch { feedback.textContent = 'Select and copy the code above.'; }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-book-form]');
    if (!form || !supportsDrawer || body.dataset.cartMode !== 'drawer') return;
    if (event.submitter && !event.submitter.matches('[data-add-button]')) return;
    event.preventDefault();
    if (addOperation) return;
    const button = form.querySelector('[data-add-button]');
    const feedback = form.querySelector('[data-product-message]');
    const oldText = button.textContent;
    addOperation = true; button.disabled = true; button.textContent = 'Adding…';
    feedback.textContent = ''; feedback.classList.remove('error');
    let added = false;
    try {
      await requestJSON(jsonEndpoint(route('cartAddUrl', '/cart/add')), { method: 'POST', body: new FormData(form) });
      added = true;
      const cart = await requestJSON(jsonEndpoint(route('cartUrl', '/cart')));
      paintCart(cart); showDrawer(button); message('Added to your bag.');
    } catch (error) {
      feedback.classList.add('error');
      if (added) {
        feedback.textContent = 'Your item was added, but the bag preview could not load. ';
        const link = el('a', 'text-link', 'View your bag'); link.href = route('cartUrl', '/cart'); feedback.append(link);
      } else feedback.textContent = error.message;
    } finally {
      addOperation = false;
      const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      button.disabled = selected ? selected.dataset.available !== 'true' : false;
      button.textContent = selected && selected.dataset.available !== 'true' ? 'Sold out' : oldText;
    }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const container = select.closest('.product-info');
    const button = container.querySelector('[data-add-button]');
    const price = container.querySelector('[data-product-price]');
    const compare = container.querySelector('[data-compare-price]');
    price.textContent = option.dataset.price;
    compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
    button.disabled = option.dataset.available !== 'true' || addOperation;
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
    const accelerated = container.querySelector('[data-dynamic-checkout]');
    if (accelerated) accelerated.hidden = option.dataset.available !== 'true';
    const quantity = container.querySelector('input[name="quantity"]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    const current = Number(quantity.value), min = Number(quantity.min), step = Number(quantity.step), max = Number(quantity.max || Infinity);
    const normalized = min + Math.max(0, Math.round((current - min) / step)) * step;
    quantity.value = String(Math.min(max, Math.max(min, normalized)));
    const feedback = container.querySelector('[data-product-message]');
    feedback.textContent = ''; feedback.classList.remove('error');
    if (!window.Shopify?.designMode) {
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    }
  });
})();
